import DataProvider from '../../../lmm-widget/src/layers/dataProviders/_base/DataProvider';
import Utils from 'helpers/Utils';

export default DataProvider.extend({
	constructor(options) {
		this.widget = options.widget;
		this.options = options;
		this.initialize();
	},

	initialize() {
		this._checkVisibility();
		DataProvider.prototype.initialize.call(this);
	},

	load() {
		let opt = {
			featureId: 'id',
			geometry: 'position'
		};
		const hotelList = Utils.transformDataToGeoJSON(
			this.widget.hotelsJson.alternativeHotelList,
			opt
        ).features;

		const bounds = new google.maps.LatLngBounds();
		hotelList.forEach(hotel => {
			bounds.union(
				Utils.getBoundsFromPoint(
					new google.maps.LatLng({
						lat: hotel.geometry.coordinates[1],
						lng: hotel.geometry.coordinates[0]
					}),
					10
				)
			);
		});
		this.widget.map.fitBounds(bounds);
		this.widget.initialBounds = bounds;
		this.trigger('PROCESS_FEATURES', hotelList, this);
	}
});



// WEBPACK FOOTER //
// ./src/layers/providers/SecondaryHotelsProvider.js